import React from "react";
import { useLabelsContext } from "../../context/LabelsContext";
import { useClubContext } from "../../context/ClubContext";
import { useAuthContext } from "../../context/AuthContext";

export const LoginFormHeader: React.FC = () => {
	const { labels } = useLabelsContext();
	const { club } = useClubContext();
	const { interestedUser } = useAuthContext();

	const headerElements: string[] | null =
		labels?.[
			interestedUser ? "verifyAndContinue" : "loginAndContinue"
		]?.split("<br/>") || null;

	const headerTitle: string =
		headerElements && headerElements.length ? headerElements[0] : "";

	const headerText: string =
		headerElements && headerElements.length > 1 ? headerElements[1] : "";

	return (
		<div className='form-header text-center'>
			{club?.clubLogoUrl && (
				<img
					className='club-logo'
					src={club?.clubLogoUrl}
					alt={club?.clubName}
				/>
			)}
			{Boolean(headerTitle) && (
				<span
					className='form-header-title'
					dangerouslySetInnerHTML={{ __html: headerTitle }}
				/>
			)}
			{Boolean(headerText) && (
				<span
					className='form-header-text'
					dangerouslySetInnerHTML={{ __html: headerText }}
				/>
			)}
		</div>
	);
};
